import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
// import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1
  }
}));

export default function ButtonAppBar(props) {
  const classes = useStyles();

  // const { setOpen } = props;
  // const handleOpen = () => {
  //   setOpen(true);
  // };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h4" className={classes.title}>
            Assignment Manager
          </Typography>
        </Toolbar>
        {/* <Button color="inherit" onClick={handleOpen}>
          Add Todo
        </Button> */}
      </AppBar>
    </div>
  );
}
